import { Paper, Typography } from '@mui/material';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { useEffect, useState } from 'react';
import { ApiResponse } from '../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../api/grid-api-key-store';
import { useLoadData } from '../../../hooks/useLoadData';
import { useSaveData } from '../../../hooks/useSaveData';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../hooks/use-debounce';
import { useNavigate } from 'react-router-dom';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
};

interface CustomGridCellProps {
  field: string;
}

interface CellProps {
  workorder: any;
}

interface IQueryGridPage {
  queryResult: any;
}

const QueryGridPage = ({ queryResult }: IQueryGridPage) => {
  // const [columns, setColumns] = useState(
  //   queryResult?.columns?.map((item: any) => ({
  //     ...item,
  //     field: item?.field?.charAt(0)?.toLowerCase() + item?.field?.slice(1),
  //   }))
  // );
  const navigate = useNavigate();
  const [columns, setColumns] = useState(queryResult?.columns);

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('CustomQueryWorkOrder', 'CustomQueryWorkOrder')
  );

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredCustomQueryWorkOrders, setFilteredCustomQueryWorkOrders] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredCustomQueryWorkOrderList = queryResult?.customReports?.filter((CustomQueryWorkOrder: any) =>
      Object.values(CustomQueryWorkOrder).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredCustomQueryWorkOrders(filteredCustomQueryWorkOrderList || []);
  }, [debouncedSearchTerm, queryResult?.customReports]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'CustomQueryWorkOrder',
      pageName: 'CustomQueryWorkOrder',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'CustomQueryWorkOrder',
      pageName: 'CustomQueryWorkOrder',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  const JobsiteCell = ({ workorder }: CellProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const handleClickJobsite = () => {
      // navigate(`/units?searchType=jobsites&searchText=${workorder?.jobsite}`);
      window.open(`/units?searchType=jobsites&searchText=${workorder?.jobsite}`, "_blank");
    };
    return (
      <td style={{ cursor: 'pointer' }} onClick={handleClickJobsite}>
        <Typography
          component="span"
          style={{
            color: isHovered ? '#0000b5' : '#0000b5',
            textDecoration: isHovered ? 'underline' : 'none',
            cursor: 'pointer',
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {workorder?.jobsite}
        </Typography>
      </td>
    );
  };

  const CustomGridCell = ({ field }: CustomGridCellProps): ((dataItem: any) => JSX.Element) | undefined => {
    if (field === 'jobsite') {
      // Return a function that takes a data item and returns a JSX element
      return (dataItem: any) => {
        return <JobsiteCell workorder={dataItem.dataItem} />;
      };
    }
    return undefined;
  };

  return (
    <div>
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='query_builder'
          columns={columns || []}
          dataItemKey="workOrderID"
          isBusy={isLoadingGridLayout}
          customCell={(field) =>
            CustomGridCell({
              field,
            })
          }
          //   customCell={(field) =>
          //     ProjectCustomGridCell({
          //       field,
          //     })
          //   }

          //   viewRoute={(value) => `details/${value.projectID}`}
          // onEdit={handleEditProject}
          //   onEdit={form.getValues('status') !== 'archived' ? handleEditProject : undefined}
          //   actionPermissions={{ edit: UserPermissionName.EDIT_PROJECT, export: UserPermissionName.DOWNLOAD_GRID }}

          // -----------------Grid Layout-------
          dataItems={filteredCustomQueryWorkOrders || []}
          reorderable
          handleSearch={handleInputChange}
          handleSaveLayout={handleSaveLayout}
          isSaveLayout={true}
          gridConfigFromApi={gridConfig}
          handleResetLayout={handleResetLayout}
        // -----------------Grid Layout-------
        />


      </Paper>
    </div>
  );
};

export default QueryGridPage;
